/**
 * Wire shapes for /api/v2/admin/users + /api/v2/admin/patients (cycle-17).
 * BE applies the shared toSnake() interceptor so every leaf field arrives
 * in snake_case + role/subscribe hydrated.
 *
 * Per the P19 plan: keep User shapes loose ([key: string]: any) — the FE
 * touches a wide field surface per consumer and the legacy GQL fragment
 * has many optional fields.
 */

// Phase E Cycle 2 canonical (BE @app/database/core.constants
// DoctorProfileStatus). Was numeric '1'..'4'.
export enum DoctorProfileStatus {
  Waiting = 'waiting',
  Active = 'active',
  Disabled = 'disabled',
  Inactive = 'inactive'
}

// Phase E Cycle 5 canonical Gender (BE shared across patients +
// doctors + treatment_forms). Was numeric '1' / '2'.
export enum Gender {
  Male = 'male',
  Female = 'female'
}

// Phase E Cycle 2 canonical PatientSource. Was numeric '1'..'4'.
export enum PatientSource {
  SignUp = 'sign_up',
  FastAppointment = 'fast_appointment',
  Another = 'another',
  Other = 'other'
}

export interface UserRole {
  id?: number;
  name: string;
}

export interface UserListRow {
  id: number;
  first_name: string;
  last_name: string;
  avatar: string | null;
  phone: string | null;
  email: string;
  confirm: number | null;
  lang: string | null;
  created_at: string;
  role: UserRole | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface UserListResponse {
  results: UserListRow[];
  total: number;
}

export interface UserListQuery {
  page?: number; // 0-based at FE; service coerces to 1-based BE
  limit?: number;
  role?: string;
  name?: string;
}

export interface PatientSubscribe {
  auto_renew_status: boolean | null;
  duration_type: number | null;
  expiration_date: string | null;
  subscription_id: number | null;
}

export interface PatientListRow extends UserListRow {
  subscribe: PatientSubscribe | null;
}

export interface PatientListResponse {
  results: PatientListRow[];
  total: number;
}

export interface PatientListQuery {
  page?: number;
  limit?: number;
  search?: string;
  start_date?: string;
  end_date?: string;
  birthday_start?: string;
  birthday_end?: string;
  gender?: Gender;
  confirm?: number;
  lang?: string;
  subscription?: number;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type UserInput = Record<string, any>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CreateDoctorInput = Record<string, any>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type UpdateUserInput = Record<string, any>;

export interface DoctorStatusInput {
  status: DoctorProfileStatus;
  lang?: string;
}
